<template>
    <newForm useTitle="true"
             v-bind:title="$t('Audit_management.audit_log')" v-bind:class="[direction ? 'k-rtl' : '' ]">
        <div class="row form-group">
            <div class="col-md-3">
                <label class="control-label">{{$t("Audit_management.from_date")}}</label>
            </div>
            <div class="col-md-9">
                <input type="text"
                       class="form-control"
                       id="fromDate"
                       autocomplete="off" />
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-3">
                <label class="control-label">{{$t("Audit_management.to_date")}}</label>
            </div>
            <div class="col-md-9">
                <input type="text"
                       class="form-control"
                       id="toDate"
                       autocomplete="off" />
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-3">
                <label class="control-label">{{$t("Audit_management.audit_type")}}</label>
            </div>
            <div class="col-md-9">
                <input type="text"
                       class="form-control"
                       id="auditType"
                       autocomplete="off" />
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-3">

            </div>
            <div class="col-md-1" style="float:left">


                <input type="button"
                       class="form-control"
                       id="reloadGrid" value="Filter"
                       @click="reload()" />
            </div>
        </div>
        <grid id="loggrid"
              v-bind:columns="columns"
              filterable="false"
              v-bind:additionalParameters="additionalParameters"
              dataSourceUrl="api/auditConfig/GetAllAudits"
              v-bind:detailConfig="detailConfig"
              v-bind:reloadGrid="reloadGrid"
              hasDetail="true"
              hasPaging="true"
              hasSearch="true"
              pagingType="numeric"
              resizable="true"
              editable="false">
        </grid>
    </newForm>

</template>

<script type="text/javascript">
    import NewForm from '../forms/newform/newForm.vue';
    import Grid from "../widgets/grid/grid.vue";
    import Helper from '../../assets/ts/helper';


    const helper = new Helper();

    export default {
        data() {
            return {
                direction: payload.currentLocale.IsRightToLeft,
                columns: [

                    { field: "AuditDate", title: i18n.$t("Audit_management.date"), menu: false, hidden: false },
                    { field: "AuditTypeName", title: i18n.$t("Audit_management.audit_type"), menu: false, hidden: false },
                    { field: "Username", title: i18n.$t("Audit_management.user_name"), menu: false, hidden: false },
                    { field: "Message", title: "Audit_management.message", menu: false, hidden: true },
                ],
                detailConfig: this.detailConfigFn,
                fromDate: $("#fromDate"),
                toDate: $("#fromDate"),
                auditType: $("#auditType"),

                reloadGrid: 0,
            }
        },
        methods: {
            AuditTypeSelected(value) {
                this.auditTypeValue = value;
            },
            detailConfigFn(e) {
                let dataItem = e.data;
               
                e.detailRow.children('td.k-detail-cell').css({ direction: "ltr", textAlign: "left" }).html(dataItem.Message);
            },
            reload() {
                this.reloadGrid++;
            },
            init() {
                this.fromDate = $("#fromDate");
                this.toDate = $("#toDate");
                this.toDate.val('');
                this.fromDate.val('');
                this.auditType.val('');

                this.auditTypeValue = null;

            },
            doAjaxRequest(url, data, onSuccess, onFailure, method) {
                let ajaxConfig = {
                    url: url,
                    data: data,
                    dataType: "json",
                    contentType: "application/json;charset=utf-8"
                };
                debugger;
                ajaxConfig.beforeSend = (xhr) => {
                    xhr.setRequestHeader("__RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
                };

                if (method) {
                    ajaxConfig.method = method;
                }
                $.ajax(ajaxConfig)
                    .done((result) => {
                        debugger;
                        if (typeof onSuccess === 'function')
                            onSuccess(result);
                    }).error((error) => {
                        console.log(error);
                        if (typeof onFailure === 'function')
                            onFailure();
                    });
            }
        },

        reLoadeData() {
            this.reloadGrid++;
        },
        updated() {
        },
        computed: {
            additionalParameters() {
                this.reloadGrid++;
                debugger;
                return {
                    fromDate: $("#fromDate").val(),
                    toDate: $("#toDate").val(),
                    auditType: $("#auditType").val()

                }
            },
        },
        mounted() {
            this.fromDate = $("#fromDate");
            this.toDate = $("#toDate");
            this.auditType = $("#auditType");

            this.fromDate.click(function (e) {
                e.stopPropagation();
            });


            this.toDate.click(function (e) {
                e.stopPropagation();
            });


            this.fromDate.MdPersianDateTimePicker({
                Placement: 'bottom',
                Trigger: 'click',
                EnableTimePicker: false,
                TargetSelector: '#fromDate',
                Format: 'yyyy/MM/dd',
                IsGregorian: payload.currentLocale.Culture !== 'fa-IR',
                EnglishNumber: true,
            });

            this.toDate.MdPersianDateTimePicker({
                Placement: 'bottom',
                Trigger: 'click',
                EnableTimePicker: false,
                TargetSelector: '#toDate',
                Format: 'yyyy/MM/dd',
                IsGregorian: payload.currentLocale.Culture !== 'fa-IR',
                EnglishNumber: true,
            });
        },
        components: {
            Grid,
            NewForm
        }
    }

</script>
